import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ae326c44"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae326c44')) {
      api.createRecord('ae326c44', component.options)
    } else {
      api.reload('ae326c44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ae326c44", function () {
      api.rerender('ae326c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdmin/Doc/index.vue"
export default component.exports